import DirectoryView from './DirectoryView';

export default DirectoryView;
